 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"analytics~hospitalizations~karte~main~notifications~ownerPatients~payments~receipts~vaccinations":"analytics~hospitalizations~karte~main~notifications~ownerPatients~payments~receipts~vaccinations","analytics":"analytics","hospitalizations":"hospitalizations","notifications":"notifications","payments":"payments","receipts~vaccinations":"receipts~vaccinations","receipts":"receipts","vaccinations":"vaccinations","column~common~diseases~display~karte~main~medicines~ownerPatients~reservation~settings~shifts~staffs~d98b1aaf":"column~common~diseases~display~karte~main~medicines~ownerPatients~reservation~settings~shifts~staffs~d98b1aaf","common~contact~karte~main~reservation~shifts":"common~contact~karte~main~reservation~shifts","main":"main","column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments":"column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments","diseases~medicines~treatments":"diseases~medicines~treatments","diseases":"diseases","medicines":"medicines","column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments":"column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments","karte":"karte","ownerPatients":"ownerPatients","column":"column","common":"common","reservation":"reservation","shifts":"shifts","treatments":"treatments","settings":"settings","template":"template","display":"display","staffs":"staffs","contact":"contact","dataImport":"dataImport"}[chunkId]||chunkId) + "." + {"analytics~hospitalizations~karte~main~notifications~ownerPatients~payments~receipts~vaccinations":"3dd447a5","analytics":"65cce5c1","hospitalizations":"df3dc653","notifications":"c76ea232","payments":"ed168f29","receipts~vaccinations":"984f0391","receipts":"68cbef4e","vaccinations":"80b29b84","column~common~diseases~display~karte~main~medicines~ownerPatients~reservation~settings~shifts~staffs~d98b1aaf":"1d49f297","common~contact~karte~main~reservation~shifts":"32e18e4a","main":"7384e149","column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments":"7257b454","diseases~medicines~treatments":"6a9c23e9","diseases":"ac2e944b","medicines":"8dc0ebaa","column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments":"34d24ae3","karte":"aa7c2a9e","ownerPatients":"8a2be538","column":"d836cb80","common":"56320214","reservation":"5a1f1890","shifts":"4f6e3124","treatments":"4ba40b80","settings":"a2d83fb5","template":"c2d593f1","display":"22d67108","staffs":"509500bd","contact":"5e3b5c64","dataImport":"46177c0d","chunk-9ece9a7e":"92cb49dd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"analytics":1,"hospitalizations":1,"notifications":1,"payments":1,"receipts~vaccinations":1,"receipts":1,"vaccinations":1,"common~contact~karte~main~reservation~shifts":1,"main":1,"column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments":1,"diseases~medicines~treatments":1,"diseases":1,"medicines":1,"column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments":1,"karte":1,"ownerPatients":1,"column":1,"common":1,"reservation":1,"shifts":1,"treatments":1,"settings":1,"template":1,"display":1,"staffs":1,"contact":1,"dataImport":1,"chunk-9ece9a7e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"analytics~hospitalizations~karte~main~notifications~ownerPatients~payments~receipts~vaccinations":"analytics~hospitalizations~karte~main~notifications~ownerPatients~payments~receipts~vaccinations","analytics":"analytics","hospitalizations":"hospitalizations","notifications":"notifications","payments":"payments","receipts~vaccinations":"receipts~vaccinations","receipts":"receipts","vaccinations":"vaccinations","column~common~diseases~display~karte~main~medicines~ownerPatients~reservation~settings~shifts~staffs~d98b1aaf":"column~common~diseases~display~karte~main~medicines~ownerPatients~reservation~settings~shifts~staffs~d98b1aaf","common~contact~karte~main~reservation~shifts":"common~contact~karte~main~reservation~shifts","main":"main","column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments":"column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments","diseases~medicines~treatments":"diseases~medicines~treatments","diseases":"diseases","medicines":"medicines","column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments":"column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments","karte":"karte","ownerPatients":"ownerPatients","column":"column","common":"common","reservation":"reservation","shifts":"shifts","treatments":"treatments","settings":"settings","template":"template","display":"display","staffs":"staffs","contact":"contact","dataImport":"dataImport"}[chunkId]||chunkId) + "." + {"analytics~hospitalizations~karte~main~notifications~ownerPatients~payments~receipts~vaccinations":"31d6cfe0","analytics":"11921790","hospitalizations":"bff8f706","notifications":"2c5ba4d0","payments":"f9bf15a2","receipts~vaccinations":"0bb53c19","receipts":"49c42fb3","vaccinations":"64680328","column~common~diseases~display~karte~main~medicines~ownerPatients~reservation~settings~shifts~staffs~d98b1aaf":"31d6cfe0","common~contact~karte~main~reservation~shifts":"b741fd71","main":"bb0498a4","column~common~diseases~medicines~ownerPatients~reservation~settings~shifts~template~treatments":"a283aa8d","diseases~medicines~treatments":"133d471a","diseases":"6bf8f872","medicines":"00d1ea05","column~common~display~karte~ownerPatients~reservation~settings~shifts~staffs~template~treatments":"ff4c5607","karte":"e892ffd8","ownerPatients":"c4d6df96","column":"f0138db0","common":"31e73093","reservation":"ff48093a","shifts":"1c524099","treatments":"526eb2af","settings":"a729bf08","template":"7e62424e","display":"b4bc63aa","staffs":"56caf139","contact":"ad6f4060","dataImport":"e2e2a1d1","chunk-9ece9a7e":"64b5d2aa"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([4,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
